import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import XlContainer from 'components/XlContainer'
import StandardLayout from 'components/StandardLayout'
import { RenderOnDesktop, RenderOnMobile } from 'components/DeviceUtils'
import CustomerBanner from 'components/CustomerBanner'
import GreyGradient from 'components/GreyGradient'
import useIsMobile from 'hooks/useIsMobile'
import ProcurementTabSection from 'views/Customers/Sections/Procurement/ProcurementTabSection'

const stackSpacing = {
    xs: 10,
    sm: 15,
    md: 15,
    lg: 15,
    xl: 15,
}

const Procurement = () => {
    const isMobile = useIsMobile()
    return (
        <>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient radial>
                        <StandardLayout sx={{ pb: 3 }}>
                            <RenderOnMobile>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `left` }}
                                >
                                    Build green supply chains through sustainable procurement
                                </Typography>
                            </RenderOnMobile>
                            <RenderOnDesktop>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    Build green supply chains
                                </Typography>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    through sustainable procurement
                                </Typography>
                            </RenderOnDesktop>
                        </StandardLayout>
                    </GreyGradient>
                </Stack>
            </XlContainer>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient hide={!isMobile}>
                        <StandardLayout sx={{ py: isMobile ? 0 : 10 }}>
                            <ProcurementTabSection />
                        </StandardLayout>
                    </GreyGradient>
                    <StandardLayout>
                        <CustomerBanner
                            image={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/certa-desktop.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            mobileImage={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/certa-mobile.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            customerLogo={'https://assets.lune.co/lune-co/client-logos/certa.png'}
                            text="Easily giving procurement related Scope 3 emissions visibility"
                        />
                    </StandardLayout>
                    <StandardLayout>
                        <CustomerBanner
                            image={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/requis-desktop.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            mobileImage={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/requis-mobile.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            customerLogo={'https://assets.lune.co/lune-co/client-logos/requis.png'}
                            text="Offering innovative carbon removal projects to their customers"
                        />
                    </StandardLayout>
                </Stack>
            </XlContainer>
        </>
    )
}

export default Procurement
